import type { RouteObject } from 'react-router';

import { BASE, NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import { reportRouteDefinitions } from './ReportRouteDefinitions';
import { generatePageWithTabsRoute } from './routeGenerator';

const ReportRoutes: RouteObject = generatePageWithTabsRoute(
  'Generate exportable reports',
  BASE.REPORTS,
  NESTED_ROUTES.REPORTS.ACCOUNT_DETAILS,
  reportRouteDefinitions,
);

export default ReportRoutes;
